/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import scrollTo from "gatsby-plugin-smoothscroll";

import Layout from "../components/layout";
import Seo from "../components/seo";
import SetLang from "../components/setLang";
import * as headingStyle from "../styles/heading.module.css";
import * as style from "./styles/services.module.css";

const ServicesPageEN = () => (
  <Layout lang="en">
    <Seo title="Services" lang="en" />
    <SetLang lang="en" />
    <section className={[style.section, style.about].join(" ")}>
      <div data-sal="fade" data-sal-duration="1000" className={style.illustration}>
        <img className={style.img} src={"/media/undraw_innovative_b409_customized.svg"} width={300} alt="" />
      </div>
      <div className={style.contentWrapper}>
        <div
          data-sal="slide-left"
          data-sal-duration="1000"
          className={[headingStyle.dash, headingStyle.gradientYellowBlue].join(" ")}
        />
        <h1 data-sal="slide-left" data-sal-duration="1000" data-sal-delay="200" className={headingStyle.heading}>
          My Services
        </h1>
        <p data-sal="slide-left" data-sal-duration="1000" data-sal-delay="400">
          From personal websites to full-blown enterprise web applications, I strive to bring the most value into your
          online presence.
        </p>
        <p data-sal="slide-left" data-sal-duration="1000" data-sal-delay="600">
          Find out more below to find the suitable package and pricing for your needs.
        </p>
        <p data-sal="slide-left" data-sal-duration="1000" data-sal-delay="800">
          Note: The prices listed below includes domain and hosting cost for the first year.
        </p>
        <div data-sal="slide-left" data-sal-duration="1000" data-sal-delay="1000" className={style.buttonBox}>
          <div className={style.buttonWrapper}>
            <button
              className={style.readMoreButton}
              onClick={() => {
                scrollTo("#first-scroll");
              }}
            >
              <div className={style.before} />
              <div className={style.after} />
              <div className={style.content}>
                <span>Read more</span>
              </div>
            </button>
            <img
              src={"/media/south_white_24dp.svg"}
              alt={""}
              onClick={() => {
                scrollTo("#first-scroll");
              }}
              onKeyDown={() => {
                scrollTo("#first-scroll");
              }}
            />
          </div>
          <div className={style.buttonWrapper}>
            <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
              <button className={style.contactButton}>
                <div className={style.before} />
                <div className={style.after} />
                <div className={style.content}>
                  <span>Contact</span>
                </div>
              </button>
            </AniLink>
          </div>
        </div>
      </div>
    </section>
    <section id="first-scroll" className={[style.section, style.service, style.service1].join(" ")}>
      <div className={style.contentWrapper}>
        <div
          data-sal="slide-right"
          data-sal-duration="1000"
          data-sal-delay="150"
          className={[headingStyle.dash, headingStyle.solidBlack].join(" ")}
        />
        <h1 data-sal="slide-right" data-sal-duration="1000" data-sal-delay="300" className={headingStyle.heading}>
          Personal Website
        </h1>
        <img
          data-sal="slide-right"
          data-sal-duration="1000"
          data-sal-delay="450"
          src={"/media/undraw_blogging_vpvv_customized.svg"}
          alt=""
          className={style.illustration}
        />
      </div>
      <div data-sal="slide-left" data-sal-duration="1000" data-sal-delay="600" className={style.priceWrapper}>
        <div className={style.priceItem}>
          <h2>Templated</h2>
          <p className={style.estTime}>Est. delivery: 7 days</p>
          <div className={style.center}>
            <p>Starting from</p>
            <div className={style.price}>$220</div>
          </div>
          <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
            <button className={style.getQuoteButton}>
              <div className={style.before} />
              <div className={style.after} />
              <div className={style.content}>
                <span>Get a quote</span>
              </div>
            </button>
          </AniLink>
        </div>
        <div className={style.priceItem}>
          <h2>Custom</h2>
          <p className={style.estTime}>Est. delivery: 14 days</p>
          <div className={style.center}>
            <p>Starting from</p>
            <div className={style.price}>$520</div>
          </div>
          <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
            <button className={style.getQuoteButton}>
              <div className={style.before} />
              <div className={style.after} />
              <div className={style.content}>
                <span>Get a quote</span>
              </div>
            </button>
          </AniLink>
        </div>
      </div>
    </section>
    <section className={[style.section, style.service, style.service2].join(" ")}>
      <div className={style.contentWrapper}>
        <div
          data-sal="slide-left"
          data-sal-duration="1000"
          data-sal-delay="150"
          className={[headingStyle.dash, headingStyle.solidBlack].join(" ")}
        />
        <h1 data-sal="slide-left" data-sal-duration="1000" data-sal-delay="300" className={headingStyle.heading}>
          Business Website
        </h1>
        <img
          data-sal="slide-left"
          data-sal-duration="1000"
          data-sal-delay="450"
          src={"/media/undraw_business_shop_qw5t_customized.svg"}
          alt=""
          className={style.illustration}
        />
      </div>
      <div data-sal="slide-right" data-sal-duration="1000" data-sal-delay="600" className={style.priceWrapper}>
        <div className={style.priceItem}>
          <h2>Templated</h2>
          <p className={style.estTime}>Est. delivery: 10 - 20 days</p>
          <div className={style.center}>
            <p>Starting from</p>
            <div className={style.price}>$640</div>
          </div>
          <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
            <button className={style.getQuoteButton}>
              <div className={style.before} />
              <div className={style.after} />
              <div className={style.content}>
                <span>Get a quote</span>
              </div>
            </button>
          </AniLink>
        </div>
        <div className={style.priceItem}>
          <h2>Custom</h2>
          <p className={style.estTime}>Est. delivery: over 30 days</p>
          <div className={style.center}>
            <p>Starting from</p>
            <div className={style.price}>$1599</div>
          </div>
          <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
            <button className={style.getQuoteButton}>
              <div className={style.before} />
              <div className={style.after} />
              <div className={style.content}>
                <span>Get a quote</span>
              </div>
            </button>
          </AniLink>
        </div>
      </div>
    </section>
    <section className={[style.section, style.service, style.service3].join(" ")}>
      <div className={style.contentWrapper}>
        <div
          data-sal="slide-right"
          data-sal-duration="1000"
          data-sal-delay="150"
          className={[headingStyle.dash, headingStyle.solidWhite].join(" ")}
        />
        <h1 data-sal="slide-right" data-sal-duration="1000" data-sal-delay="300" className={headingStyle.heading}>
          E-commerce Platform
        </h1>
        <img
          data-sal="slide-right"
          data-sal-duration="1000"
          data-sal-delay="450"
          src={"/media/undraw_add_to_cart_vkjp_customized.svg"}
          alt=""
          className={style.illustration}
        />
      </div>
      <div data-sal="slide-left" data-sal-duration="1000" data-sal-delay="600" className={style.priceWrapper}>
        <div className={style.priceItem}>
          <h2>Custom</h2>
          <p className={style.estTime}>Est. delivery: over 3 months</p>
          <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
            <button className={style.getQuoteButton}>
              <div className={style.before} />
              <div className={style.after} />
              <div className={style.content}>
                <span>Get a quote</span>
              </div>
            </button>
          </AniLink>
        </div>
      </div>
    </section>
    <section className={[style.section, style.message].join(" ")}>
      <div className={style.contentWrapper}>
        <div
          data-sal="slide-down"
          data-sal-duration="1000"
          data-sal-delay="150"
          className={[headingStyle.dash, headingStyle.solidWhite].join(" ")}
        />
        <h1 data-sal="slide-down" data-sal-duration="1000" data-sal-delay="300" className={headingStyle.heading}>
          Don't find a suitable option here?
        </h1>
        <p data-sal="slide-up" data-sal-duration="1000" data-sal-delay="450">
          <span className={"animated-anchor"}>
            <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/contact/"}>
              Contact me
            </AniLink>
          </span>{" "}
          for a detailed consultation
        </p>
      </div>
    </section>
  </Layout>
);

export default ServicesPageEN;
